export default class Icon {
    constructor(name:string, path:string) {
        this.name = name;
        this.path = path;
    }

    name:string;
    path:string;
}